export const APP_INVITE_START_PARAMETER = "invite";

export type ShareEntrySource =
  | "app_invite"
  | "shared_list"
  | "shared_product"
  | "shared_catalog";

export type AppEntrySource =
  | ShareEntrySource
  | "inline_product"
  | "welcome"
  | "menu"
  | "rescue"
  | "direct";

const SHARED_LIST_START_PATTERN = /^list_[a-f\d]{36}$/;
const SHARED_PRODUCT_START_PATTERN = /^product_[a-f\d]{36}$/;
const INLINE_PRODUCT_START_PATTERN =
  /^inline_[a-f\d]{12}_[a-z\d_-]{1,128}$/i;
const SHARED_CATALOG_START_PATTERN =
  /^catalog_[a-f\d]{12}_(?:[1-9]\d{0,2}|1\d{3}|2000)$/;
const RESCUE_START_PATTERN = /^rescue(?:_|$)/;

export function normalizeAppEntrySource(
  value: unknown,
): AppEntrySource | null {
  switch (value) {
    case "app_invite":
    case "shared_list":
    case "shared_product":
    case "inline_product":
    case "shared_catalog":
    case "welcome":
    case "menu":
    case "rescue":
    case "direct":
      return value;
    default:
      return null;
  }
}

export function shareEntrySourceFromStartParameter(
  value: string | null,
): ShareEntrySource | null {
  if (value === APP_INVITE_START_PARAMETER) {
    return "app_invite";
  }
  if (value && SHARED_LIST_START_PATTERN.test(value)) {
    return "shared_list";
  }
  if (value && SHARED_PRODUCT_START_PATTERN.test(value)) {
    return "shared_product";
  }
  if (value && INLINE_PRODUCT_START_PATTERN.test(value)) {
    return "shared_product";
  }
  if (value && SHARED_CATALOG_START_PATTERN.test(value)) {
    return "shared_catalog";
  }
  return null;
}

export function appEntrySourceFromStartParameter(
  value: string | null,
): AppEntrySource | null {
  if (value && INLINE_PRODUCT_START_PATTERN.test(value)) {
    return "inline_product";
  }
  return (
    shareEntrySourceFromStartParameter(value) ??
    (value === "welcome" ? "welcome" : null) ??
    (value && RESCUE_START_PATTERN.test(value) ? "rescue" : null)
  );
}

export function initialAppEntrySource(
  startParameter: string | null,
  search: string,
): AppEntrySource {
  const signedRoute = appEntrySourceFromStartParameter(startParameter);
  if (signedRoute) {
    return signedRoute;
  }
  const hinted = normalizeAppEntrySource(
    new URLSearchParams(search).get("entry"),
  );
  return hinted === "welcome" || hinted === "menu" ? hinted : "direct";
}
